/* tslint:disable */
import React, { useRef } from 'react';
import { animated, config, useChain, useTransition } from 'react-spring';
import styled from '@emotion/styled';
import { theme } from '@kindur/components';
import withTracking from './withTracking';
import NavbarLinks from './NavbarLinks';

const SideBarContainer = styled('div')`
  ${theme.breakpoints.tabletLandscapeUp} {
    display: none;
  }
`;

const Main = styled(animated.div)`
  background-color: ${theme.colors.White};
  box-shadow: 1px 0 10px rgba(0, 0, 0, 0.25);
  height: 100vh;
  position: fixed;
  width: 18.75rem;
  z-index: 100;
`;

const Container = styled('div')`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  padding: 1.5rem 1.5rem 1.5rem calc(10% + 1.5rem);

  a:first-of-type {
    margin-bottom: 1em;
  }
`;

export interface SidebarProps {
  headerHeight: number;
  location: any;
  targets: any;
  track: (name: string, useComponentName?: string) => void;
  setSidebarVisible: (doit: boolean) => void;
  show: any;
}
const TrackComponentName = 'Sidebar';

const Sidebar = ({ setSidebarVisible, show, track }: SidebarProps) => {
  const sidebarRef = useRef();
  const transition = useTransition(show, null, {
    from: {
      transform: 'translateX(-100%)'
    },
    enter: {
      transform: 'translateX(-10%)'
    },
    leave: {
      transform: 'translateY(-100%)'
    },
    unique: true,
    config: config.stiff,
    ref: sidebarRef
  });

  useChain([sidebarRef]);

  return transition.map(({ item, key, props }) =>
    item ? (
      <SideBarContainer key={key}>
        <Main style={props}>
          <Container>
            <NavbarLinks
              track={track}
              trackComponentName={TrackComponentName}
              setSidebarVisible={setSidebarVisible}
              closeSidebar={() => {}}
            />
          </Container>
        </Main>
      </SideBarContainer>
    ) : null
  );
};

Sidebar.displayName = TrackComponentName;

export default withTracking(Sidebar);
